import {
  jsonForm,
  get,
  formPost,
  formPut,
  urlPut,
  jsonDelete,
  formDelete,
  jsonPost,
} from '../utils/request';

// plugin List
export const getplugnList = (query) => {
  return get(window.$intercept.intercept2 + '/plugin/plugin', query);
};
// plugin add
export const getAddList = (query) => {
  return formPost(window.$intercept.intercept2 + '/plugin/plugin', query);
};
// plugin edit

export const getEditList = (query, id) => {
  return formPut(window.$intercept.intercept2 + '/plugin/plugin/' + id, query);
};

// plugin deleteTaskByIds
export const getDelete = (query) => {
  return jsonPost(
    window.$intercept.intercept2 + '/plugin/deletePluginByIds',
    query,
  );
};
// plugin Uploa
export const geUploadList = (query) => {
  return formPost(
    window.$intercept.intercept2 + '/plugin/uploadPluginFile',
    query,
  );
};
